const colorsArray = [
    { label: "Blue",       value: "#0072B2" },
    { label: "Vermillion", value: "#D55E00" },
    { label: "Teal",       value: "#009E73" },
    { label: "Orange",     value: "#E69F00" },
    { label: "Sky Blue",   value: "#56B4E9" },
    { label: "Pink",       value: "#CC79A7" },
    { label: "Black",      value: "#000000" },
    { label: "Purple",     value: "#6A0DAD" },
    { label: "Crimson",    value: "#DC143C" },
    { label: "Slate",      value: "#4E5D6C" },
  ];

  const colorsArrayDisPlayOrder = [
    { label: "Blue",       value: "#0072B2" },
    { label: "Vermillion", value: "#D55E00" },
    { label: "Teal",       value: "#009E73" },
    { label: "Orange",     value: "#E69F00" },
    { label: "Sky Blue",   value: "#56B4E9" },
    { label: "Pink",       value: "#CC79A7" },
    { label: "Black",      value: "#000000" },
    { label: "Purple",     value: "#6A0DAD" },
    { label: "Crimson",    value: "#DC143C" },
    { label: "Slate",      value: "#4E5D6C" },
  ];

const gridUnitSizes = [
    {
      label: "Very small",
      gridValues: "20x20",
      value: 15
    },
    {
      label: "Small",
      gridValues: "10x10",
      value: 24
    },
    { 
      label: "Medium",
      gridValues: "10x10",
      value: 38
    },
    {
      label: "Large",
      gridValues: "6x6",
      value: 72
    },
    {
      label: "Very large",
      gridValues: "2x2",
      value: 100
    },
  ];

  const AngleDisplayOptions = [
    {
      label: "Angle displayed (by an arc) is the smallest angle, and always positive, question author can designate the reference (that is the axis from which the angle is referred. The reference can be at any angle compared to the +x axis). Question author can designate the reference",
      value: 1,
    },
    {
      label: "Angle displayed (by an arc) is chosen to start from the reference and go either clockwise or counterclockwise, and always is positive. Question author can designate the reference, and CC/CCW option",
      value: 2,
    },
    {
      label: "Angle displayed (by an arc) starts from the +x axis as the reference and will be the smallest angle, but will be indicated as positive number if the angle is CCW from the reference and negative if CW from the reference",
      value: 3,
    }
  ];

  const evaluateOptions = [
    {
      label: "=",
      value: 0,
    },
    {
      label: ">",
      value: 1,
    },
    {
      label: "<",
      value: 2,
    },
    {
      label: ">=",
      value: 3,
    },
    {
      label: "<=",
      value: 4,
    }
  ];
  const QueryOptions = [
    {
      label: "AND",
      value: 0,
    },
    {
      label: "OR",
      value: 1,
    }
  ];

  const getColorsArrayDisPlayOrder = (index) =>{
	return colorsArrayDisPlayOrder[index%colorsArrayDisPlayOrder.length].value
  }

  // Assiment matrix color based on name
  const AssignmentMatrixColorPalette = [
    { "bg": "#e6194B", "border": "#b20030", "textColor": "#000000" },
    { "bg": "#3cb44b", "border": "#2a7d2a", "textColor": "#000000" },
    { "bg": "#ffe119", "border": "#c7b800", "textColor": "#000000" },
    { "bg": "#4363d8", "border": "#2a3a9d", "textColor": "#FFFFFF" },
    { "bg": "#f58231", "border": "#b25020", "textColor": "#000000" },
    { "bg": "#911eb4", "border": "#600f80", "textColor": "#FFFFFF" },
    { "bg": "#42d4f4", "border": "#2aa0aa", "textColor": "#000000" },
    { "bg": "#f032e6", "border": "#b20db2", "textColor": "#000000" },
    { "bg": "#bfef45", "border": "#8cc732", "textColor": "#000000" },
    { "bg": "#fabed4", "border": "#e07a9a", "textColor": "#000000" },
    { "bg": "#469990", "border": "#2e6660", "textColor": "#000000" },
    { "bg": "#dcbeff", "border": "#aa99cc", "textColor": "#000000" },
    { "bg": "#9A6324", "border": "#6d4318", "textColor": "#FFFFFF" },
    { "bg": "#fffac8", "border": "#e6d99a", "textColor": "#000000" },
    { "bg": "#800000", "border": "#550000", "textColor": "#FFFFFF" },
    { "bg": "#aaffc3", "border": "#66cc99", "textColor": "#000000" },
    { "bg": "#808000", "border": "#505000", "textColor": "#000000" },
    { "bg": "#ffd8b1", "border": "#e6a87c", "textColor": "#000000" },
    { "bg": "#000075", "border": "#000050", "textColor": "#FFFFFF" },
    { "bg": "#a9a9a9", "border": "#707070", "textColor": "#000000" },
    { "bg": "#8bea93", "border": "#35db42", "textColor": "#000000" },
    { "bg": "#614fe5", "border": "#2c19b5", "textColor": "#FFFFFF" },
    { "bg": "#d1a852", "border": "#957227", "textColor": "#000000" },
    { "bg": "#cfe95c", "border": "#a6c51a", "textColor": "#000000" },
    { "bg": "#d24ca9", "border": "#942471", "textColor": "#000000" },
    { "bg": "#57cce0", "border": "#209cb1", "textColor": "#000000" },
    { "bg": "#e1d48a", "border": "#ccb739", "textColor": "#000000" },
    { "bg": "#98d6e6", "border": "#46b5d2", "textColor": "#000000" },
    { "bg": "#c871f7", "border": "#a310f3", "textColor": "#000000" },
    { "bg": "#1da1e1", "border": "#116087", "textColor": "#000000" },
    { "bg": "#e968b5", "border": "#ce1d87", "textColor": "#000000" },
    { "bg": "#bd4bd1", "border": "#812592", "textColor": "#000000" },
    { "bg": "#b750d9", "border": "#8122a0", "textColor": "#000000" },
    { "bg": "#e53178", "border": "#9d1349", "textColor": "#000000" },
    { "bg": "#6789f2", "border": "#1244e1", "textColor": "#000000" },
    { "bg": "#7bdb68", "border": "#41b32a", "textColor": "#000000" },
    { "bg": "#2d3aee", "border": "#0d17a9", "textColor": "#FFFFFF" },
    { "bg": "#72fba0", "border": "#0ff85c", "textColor": "#000000" },
    { "bg": "#e496d6", "border": "#d044b6", "textColor": "#000000" },
    { "bg": "#d87e60", "border": "#a94829", "textColor": "#000000" }
]

const SubjectColorPalette = [
  { bg: "#332288", name: "Deep Blue" },
  { bg: "#117733", name: "Forest Green" },
  { bg: "#44AA99", name: "Teal" },
  { bg: "#88CCEE", name: "Sky Blue" },
  { bg: "#DDCC77", name: "Sand Yellow" },
  { bg: "#CC6677", name: "Rose" },
  { bg: "#AA4499", name: "Purple" },
  { bg: "#882255", name: "Maroon" },
  { bg: "#999933", name: "Olive" },
  { bg: "#E69F00", name: "Orange" }
];

const TopicColorPalette = [
  { bg: "#1B9E77", name: "Dark Teal" },
  { bg: "#D95F02", name: "Rust Orange" },
  { bg: "#7570B3", name: "Indigo" },
  { bg: "#E7298A", name: "Magenta" },
  { bg: "#66A61E", name: "Moss Green" },
  { bg: "#E6AB02", name: "Mustard" },
  { bg: "#A6761D", name: "Brown" },
  { bg: "#666666", name: "Charcoal" },
  { bg: "#0072B2", name: "Royal Blue" },
  { bg: "#A40E4C", name: "Deep Rose" },
  { bg: "#005F73", name: "Ocean Blue" },
  { bg: "#9A3E25", name: "Clay Red" },
  { bg: "#7B3294", name: "Plum" },
  { bg: "#238B45", name: "Forest" },
  { bg: "#984EA3", name: "Violet" },
  { bg: "#FF7F00", name: "Bright Orange" },
  { bg: "#117A65", name: "Emerald Green" },
  { bg: "#4D4D4D", name: "Slate Gray" },
  { bg: "#993404", name: "Chestnut" },
  { bg: "#1F78B4", name: "Steel Blue" }
];
  const getRandomColorForSubjectMatrix = (name) =>{
    const randomIndex = Math.floor(Math.random() * SubjectColorPalette.length);
    return SubjectColorPalette[randomIndex].bg;
  }
    const getRandomColorForTopicMatrix = (name) =>{
    const randomIndex = Math.floor(Math.random() * TopicColorPalette.length);
    return TopicColorPalette[randomIndex].bg;
  }

  const generateLabelForName = (name) =>{
    if (!name) return "";
        let shortForm   = name.split(" ").map(word => word[0]?.toUpperCase()).join("").slice(0, 2); // Max 2 letters     
        return shortForm
  }
  const toRoman = (num) => {
    const romanNumerals = ['m','cm','d','cd','c','xc','l','xl','x','ix','v','iv','i'];
    const values = [1000,900,500,400,100,90,50,40,10,9,5,4,1];
    let result = '';
    for (let i = 0; i < values.length; i++) {
      while (num >= values[i]) {
        result += romanNumerals[i];
        num -= values[i];
      }
    }
    return result;
  };

  const subQuestionEvalOptions = [
    { id: 'dichotomous', label: 'Dichotomous',value:0 },
    { id: 'weighted', label: 'Weighted',value:1 },
    { id: 'nongraded', label: 'Non Graded',value:2 },
  ];
  export { colorsArray, colorsArrayDisPlayOrder, gridUnitSizes, AngleDisplayOptions, getColorsArrayDisPlayOrder,evaluateOptions,QueryOptions,
            AssignmentMatrixColorPalette, getRandomColorForSubjectMatrix,getRandomColorForTopicMatrix, generateLabelForName,SubjectColorPalette,TopicColorPalette,subQuestionEvalOptions,toRoman
   };